<template>
  <div class="block page18 f-c">
    <PageHeader
      :title="moduleData['2_5_1_1']"
      :sub-title="moduleData['2_5_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page18-body f-c">
      <TableNav width="1749px" style="height: 70px; margin-bottom: 25px">
        <template v-slot:title>
          <div class="page18-table-header">
            <div class="page18-table-title">
              {{ moduleData["2_5_2_2_h1"] }}
            </div>
            <div class="page18-table-sub-title">
              {{ moduleData["2_5_2_2_h2"] }}
            </div>
          </div>
        </template>
      </TableNav>
      <div style="flex-grow: 1; width: 1749px;display: flex;flex-direction: column;justify-content: space-between">
        <PTable :col-data="colData" :row-data="rowData" style="min-height: 706px">
          <Empty :text="PAGE_TEXT[commonLang].noCircleCoverage" v-if="!rowData.length"/>
        </PTable>
        <div
          v-if="reportCustomization.showWater"
          class="page-tips2"
        >{{ PAGE_TEXT[commonLang].moreInfo }}</div>
      </div>
      <div v-if="reportCustomization.showDataSource" class="page18-map-tips">
        {{ PAGE_TEXT[commonLang].dataSource }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import Empty from "./components/Empty";

const props = defineProps({
    pageNum: String,
    moduleData: {
      type: Object,
      default: () =>{}
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
});

const PAGE_TEXT = {
  'zh': {
    serialNumber: '序号',
    circleName: '商圈名称',
    district: '所属区',
    circlePositioning: '商圈定位',
    mallCount: '覆盖商场数量',
    noCircleCoverage: '当前区域暂无商圈覆盖',
    moreInfo: '>更多详情于APP「商圈调研」中查看',
    dataSource: '数据来源：全网商业数据整合'
  },
  'en': {
    serialNumber: 'No.',
    circleName: 'Business Circle Name',
    district: 'District',
    circlePositioning: 'Business Circle Positioning',
    mallCount: 'Number of Malls Covered',
    noCircleCoverage: 'No business circle coverage in current area',
    moreInfo: '',
    dataSource: 'Data Source: Whole network commercial data integration'
  }
};

const colData = computed(() => [
  { prop: "id", width: "109px", label: PAGE_TEXT[props.commonLang].serialNumber },
  { prop: "circle_name", width: "538px", label: PAGE_TEXT[props.commonLang].circleName },
  { prop: "district", width: "279px", label: PAGE_TEXT[props.commonLang].district },
  {
    prop: "business_circle_positioning",
    width: "408.63px",
    label: PAGE_TEXT[props.commonLang].circlePositioning,
  },
  { prop: "business_num", width: "408.63px", label: PAGE_TEXT[props.commonLang].mallCount },
]);
const rowData = computed(() => {
  return props.moduleData["2_5_4_4"].slice(0,10);
});
</script>

<style scoped lang="less">
.page18 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page18-body {
    flex-grow: 1;
    padding: 17px 20px 0 39px;
    .page18-table-header {
      display: flex;
      .page18-table-title {
        font-size: 36px;
      }
      .page18-table-sub-title {
        font-size: 21px;
      }
    }
    .page18-map-tips {
      width: 100%;
      flex-shrink: 0;
      text-align: right;
      height: 28px;
      font-size: 20px;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 28px;
    }
  }
}
</style>
